<template>
  <b-container class="py-4">
    <b-jumbotron class="text-center">
      <h1 class="display-3 mb-3">Greska</h1>
      <p class="lead">Sadržaj koji tražite nije pronađen!</p>
      <hr />
      <b-button variant="primary" :to="{name: 'home'}">
        <i class="fas fa-home"></i>
        Nazad na početnu stranu
      </b-button>
    </b-jumbotron>
  </b-container>
</template>

<script>
export default {};
</script>

<style>
</style>
